import config from '../config';
import { requestJson } from './http';

const toQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return query ? `?${query}` : '';
};

/**
 * Active communities with member counts, biggest first.
 * @param {{ search?: string, type?: string, countryId?: number }} [params]
 * @returns {Promise<{ total: number, communities: object[] }>}
 */
export const getCommunities = (params) =>
  requestJson(`${config.apiUrl}/community${toQuery(params)}`, {}, 'Failed to load communities');

/** Community types and social networks the server accepts. */
export const getCommunityOptions = () =>
  requestJson(`${config.apiUrl}/community/options`, {}, 'Failed to load community options');

/** Community details: contact info, social links, admin and member count. */
export const getCommunity = (communityId) =>
  requestJson(`${config.apiUrl}/community/${communityId}`, {}, 'Failed to load community');

/**
 * Members (admin first), paginated.
 * @param {{ limit?: number, offset?: number }} [params]
 */
export const getCommunityMembers = (communityId, params) =>
  requestJson(
    `${config.apiUrl}/community/${communityId}/members${toQuery(params)}`,
    {},
    'Failed to load members'
  );

/** The user's community summary, or `{ community: null }`. */
export const getUserCommunity = (userId) =>
  requestJson(`${config.apiUrl}/community/user/${userId}`, {}, 'Failed to load your community');

/**
 * Join a community. If the user is already in another one the server answers
 * 409 with `body.code === 'ALREADY_IN_COMMUNITY'`; pass `switchCommunity` to
 * leave it and join this one.
 */
export const joinCommunity = (communityId, userId, { switchCommunity = false } = {}) =>
  requestJson(
    `${config.apiUrl}/community/${communityId}/join`,
    { method: 'POST', json: { userId, switch: switchCommunity } },
    'Failed to join community'
  );

/** Leave the current community. Community admins get 409. */
export const leaveCommunity = (userId) =>
  requestJson(
    `${config.apiUrl}/community/leave`,
    { method: 'POST', json: { userId } },
    'Failed to leave community'
  );
